module.exports = __webpack_public_path__ + "media/images/posts/no_deal_with_vendors-86307202dd565001b552392c94135930.jpg";